import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AppThemeProvider } from '@reachinsight-app/shared/src/theme/ThemeProvider'
import { PostHogProvider } from '@reachinsight-app/shared/src'
import { RosApp } from './components/RosApp'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <PostHogProvider>
        <AppThemeProvider>
          <RosApp />
        </AppThemeProvider>
      </PostHogProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
